import { render, staticRenderFns } from "./DeleteRewardConfirm.vue?vue&type=template&id=1d6fd1ea&"
import script from "./DeleteRewardConfirm.vue?vue&type=script&lang=ts&"
export * from "./DeleteRewardConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports